import { Key } from 'src/web/components/ActionTable/types';

export const parseKeyDataPendingMember = (
  key: Key
): { id: string; email: string } => {
  // key should be a string in `${id}-${email}` format
  const [id, email] = key.toString().split('-');
  return { id, email };
};

export const parseKeyDataActiveMember = (
  key: Key
): { enrolmentId: string; userId: string } => {
  // key should be a string in `${enrolmentId}-${userId}` format
  const [enrolmentId, userId] = key.toString().split('-');
  return { enrolmentId, userId };
};
